<template>
  <div class="wordcloud-container">
    <div class="wordcloud-outer">
      <div
        class="wordcloud-inner"
        :style="{
          transformOrigin: '0 0',
          transform: `translate(${transform.x}px,${transform.y}px)scale(${transform.k})`
        }"
      >
        <span
          v-for="d in words.filter(d => d.value.count > 0)"
          :key="d.key"
          class="word"
          :style="{
            fontSize: `${Math.sqrt(d.value.count) * sizeFactor}px`,
            color: color(d.key),
            opacity: opacity(d.key) ? 0.3 : 1,
            cursor: 'pointer'
          }"
          @click="onClick(d, $event)"
          @contextmenu="onRightClick(d, $event)"
        >
          {{ d.key }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { zoom, zoomIdentity } from "d3-zoom";
import { select, event } from "d3-selection";
const getEvent = () => event;

export default {
  props: {
    words: {
      type: Array,
      default: () => []
    },
    color: {
      type: Function,
      required: true
    },
    opacity: {
      type: Function,
      required: true
    },
    enableZoom: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    transform: zoomIdentity,
    sizeFactor: 8
  }),
  watch: {
    words() {
      this.transform = zoomIdentity;
    },
    enableZoom(value) {
      if (value) {
        select(this.$el)
          .call(this.zoom)
          .call(this.zoom.transform, this.transform);
      } else {
        select(this.$el).on(".zoom", null);
      }
    }
  },
  mounted() {
    this.zoom = zoom().on("zoom", this.zoomed);
    if (this.enableZoom) {
      select(this.$el)
        .call(this.zoom)
        .call(this.zoom.transform, this.transform);
    }
  },
  methods: {
    zoomed() {
      const t = getEvent().transform;
      this.transform = t;
    },
    onClick(d) {
      this.$emit("click-word", d);
    },
    onRightClick(d, event) {
      event.preventDefault();
      this.$emit("right-click-word", d, event);
    }
  }
};
</script>

<style scoped>
.wordcloud-outer {
  padding: 4rem 5rem 7rem 5rem;
  line-height: 1.25;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.wordcloud-inner {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.word {
  margin: 0.125rem 0.25rem;
}
</style>
